import styled from 'styled-components';


export const StdH1 = styled.h1`
  color: ${(props) => props.color};
  margin: unset;
  font-family: ${(props) => props.$family};
  font-weight: 200;
  font-size: clamp(2rem, 1.28rem + 2.06vw, 3.75rem);
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
`;
export const StdH2 = styled.h2`
  color: ${(props) => props.color};
  margin: unset;
  font-family: ${(props) => props.$family};
  font-weight: 200;
  font-size: clamp(2.5rem, 2.09rem + 1.18vw, 3.5rem);
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
`;
export const StdH3Big = styled.h3`
  color: ${(props) => props.color};
  margin: unset;
  font-family: ${(props) => props.$family};
  font-weight: 200;
  font-size: clamp(2rem, 1.28rem + 2.06vw, 3.75rem);
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
`;

export const StdH3Small = styled.h3`
  color: ${(props) => props.color};
  margin: unset;
  font-family: ${(props) => props.$family};
  font-weight: 200;
  font-size: clamp(1.38rem, 1.22rem + 0.44vw, 1.75rem);
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
`;

export const StdFontText = styled.span`
  color: ${(props) => props.color};
  margin: unset;
  font-family: ${(props) => props.$family};
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
  letter-spacing: calc(-0.02em + 0.02rem); 
`;
